import type { BoardSize } from '@wx-weiqi/contracts';

const CLASSROOM_BOARD_SIZES: readonly BoardSize[] = [9, 13, 19];

export function ClassroomBoardSizeMenu({
  currentSize,
  disabled,
  onSelect,
  pendingSize,
  onCancel,
  onConfirm,
}: {
  readonly currentSize: BoardSize;
  readonly disabled: boolean;
  readonly onSelect: (size: BoardSize) => void;
  readonly pendingSize: BoardSize | null;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}) {
  if (pendingSize !== null) {
    return (
      <div
        className="classroom-board-size-menu classroom-board-size-menu--confirm"
        role="dialog"
        aria-label="确认切换棋盘"
      >
        <strong>切换为{pendingSize}路棋盘？</strong>
        <p>当前棋子、手数、标记和已加载的野狐棋谱将清空，课堂笔记会保留。</p>
        <div className="classroom-board-size-confirm-actions">
          <button type="button" onClick={onCancel} autoFocus>
            取消
          </button>
          <button type="button" disabled={disabled} onClick={onConfirm}>
            确认切换
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="classroom-board-size-menu" role="group" aria-label="棋盘路数">
      {CLASSROOM_BOARD_SIZES.map((size) => (
        <button
          key={size}
          type="button"
          aria-pressed={size === currentSize}
          disabled={disabled}
          onClick={() => onSelect(size)}
        >
          <span>{size}路</span>
          {size === currentSize ? <small>当前</small> : null}
        </button>
      ))}
    </div>
  );
}
